import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { errMsg } from "../lib/api";
import { ArrowLeft, UserPlus, PhoneCall } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", phone: "", email: "", password: "", address: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Kayıt başarılı! Hesabınız onay bekliyor.");
      nav("/menu");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0C] flex items-center justify-center px-5 py-10 relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <Link to="/" className="absolute top-6 left-6 text-zinc-400 hover:text-[#FFE599] flex items-center gap-2 text-sm" data-testid="register-back-btn">
        <ArrowLeft size={16} /> Ana Sayfa
      </Link>
      <div className="relative w-full max-w-md card-lux p-8 sm:p-10 fade-up" data-testid="register-card">
        <div className="text-center mb-6">
          <img src="/cafein-icon.png" alt="CAFE-İN" className="h-16 w-16 object-contain mx-auto" />
          <h1 className="mt-4 font-serif text-3xl gold-text">Müşteri Kaydı</h1>
        </div>

        <div className="mb-6 flex items-start gap-3 rounded-xl bg-amber-950/40 border border-amber-500/30 px-4 py-3">
          <PhoneCall size={18} className="text-amber-400 shrink-0 mt-0.5" />
          <p className="text-xs text-amber-200/90 leading-relaxed">
            Paket sipariş için üyelik gereklidir. Sahte siparişleri önlemek için üyeliğiniz telefonla doğrulanır: kayıttan sonra <strong>verdiğiniz telefon numarasından</strong> aranıp üyeliğiniz onaylanır, ardından sipariş verebilirsiniz.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">Ad Soyad</label>
            <input required value={form.name} onChange={set("name")} className="lux-input mt-2" placeholder="Adınız Soyadınız" data-testid="register-name" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">Telefon</label>
            <input required value={form.phone} onChange={set("phone")} className="lux-input mt-2" placeholder="05XX XXX XX XX" data-testid="register-phone" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">E-posta</label>
            <input type="email" required value={form.email} onChange={set("email")} className="lux-input mt-2" placeholder="ornek@mail.com" data-testid="register-email" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">Şifre</label>
            <input type="password" required minLength={6} value={form.password} onChange={set("password")} className="lux-input mt-2" placeholder="En az 6 karakter" data-testid="register-password" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">Adres <span className="text-zinc-600 normal-case tracking-normal">(paket teslimat için)</span></label>
            <textarea value={form.address} onChange={set("address")} rows={2} className="lux-input mt-2 resize-none" placeholder="Mahalle, sokak, bina/daire no, tarif" data-testid="register-address" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full py-3 rounded-xl flex items-center justify-center gap-2" data-testid="register-submit">
            <UserPlus size={18} /> {busy ? "Kaydediliyor..." : "Kayıt Ol"}
          </button>
        </form>
        <p className="text-center text-sm text-zinc-400 mt-6">
          Zaten hesabınız var mı? <Link to="/giris" className="text-[#FFE599] hover:underline" data-testid="register-login-link">Giriş Yapın</Link>
        </p>
      </div>
    </div>
  );
}
